import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, shallowEqual } from 'react-redux';
import { useMediaQuery } from '@material-ui/core';
import { sizes } from 'src/styles/Media.styled';
import Button from 'src/common/refactoredComponents/button/Button';
import Spinner from 'src/common/refactoredComponents/spinner/Spinner';
import { ButtonStyles } from 'src/constants/buttonStyles';
import ExportIcon from 'src/assets/images/Export.svg';
import FilterResultsPanel from 'src/common/organisms/filterResultsPanel/FilterResultsPanel';
import {
    DesktopFilterPanelWrapper,
    ExportIconImg,
    ExportSpinnerWrapper,
    MobileFilterPanelWrapper,
    ResultsActions,
    ResultsCount,
    ResultsHeaderRow,
    ResultsLeft,
    ResultsRight,
} from './index.styled';

const SetsResultsHeader = ({
    resultsCount = 0,
    onExport = () => {},
    onClearFilters = () => {},  
    loadingExport = false,
    setsAppliedFilters = [],
    onOpenFilters = () => {},
}) => {
    const { t } = useTranslation();
    const isMobile = useMediaQuery(`(max-width:${sizes.mobileDevice}px)`);
    const {appliedFilterNames} = useSelector(
        (state) => state.inventoryPreferenceReducer.setsFilterData || {},
        shallowEqual
    );

    return (
        <ResultsHeaderRow id="sets-results-row">
            <ResultsLeft id="sets-results-row-left">
                <ResultsCount id="sets-results-count">
                    {t('receiveSets.setsInventory.resultsCount', { resultsCount })}
                </ResultsCount>
                {!isMobile && setsAppliedFilters.length > 0 && (
                    <DesktopFilterPanelWrapper>
                        <FilterResultsPanel
                            id="more-sets-inventory-filter-results-panel"
                            appliedFilters={setsAppliedFilters}
                            clearFilterHandler={onClearFilters}
                            fimDashboardFilterResultsPanel={true}
                            noExtraBorder={true}
                            backgroundColor="transparent"
                            containerMargin={"0px 5px 0px 0px"}
                            onMoreClick={onOpenFilters}
                            filtersWidth={'391px'}
                        />
                    </DesktopFilterPanelWrapper>
                )}
            </ResultsLeft>
            {isMobile && setsAppliedFilters.length > 0 && (
                <MobileFilterPanelWrapper>
                    <FilterResultsPanel
                        id="more-sets-inventory-filter-results-panel"
                        appliedFilters={setsAppliedFilters}
                        clearFilterHandler={onClearFilters}
                        fimDashboardFilterResultsPanel={true}
                        noExtraBorder={true}
                        backgroundColor="transparent"
                        mobileBackgroundColor="transparent"
                        filterContainerMobilePadding="0"
                        widthTemplate={true}
                        marginLeftTemplate={true}
                        marginTop={'0px'}
                        onMoreClick={onOpenFilters}
                    />
                </MobileFilterPanelWrapper>
            )}
           {resultsCount > 0 && (
            <ResultsActions id="sets-results-actions">
                <Button
                    id="receiveSets-setsInventory-export"
                    clicked={onExport}
                    disabled={loadingExport}
                    variant={ButtonStyles.secondary}
                    borderRadius="20px"
                    height="32px"
                    minWidth={isMobile ? undefined : '110px'}
                    width={isMobile ? undefined : '110px'}
                    fontSize="14px"
                    fontFamily="AvenirNextWorld Demi"
                    padding="0 10px"
                    // minWidth={isMobileView ? undefined : '110px'}
                    // width={isMobileView ? undefined : '110px'}
                    WhiteSpace="nowrap"
                >
                    {loadingExport ? (
                        <ExportSpinnerWrapper>
                            <Spinner
                                id="receiveSets-setsInventory-export-loading-spinner"
                                animation="border"
                                variant="primary"
                                small
                            />
                        </ExportSpinnerWrapper>
                    ) : (
                        <>
                            <ExportIconImg src={ExportIcon} alt="export" />
                            {t('receiveSets.InventoryConsigned.export')}
                        </>
                    )}
                </Button>
            </ResultsActions>
            )}
        </ResultsHeaderRow>
    );
};

export default SetsResultsHeader;
